export default {
  SEARCH_TEXT: 'search_searchText',
  SEARCH_ACTIVE_HIT: 'search_activeHit',
  SEARCH_USER_FILTER: 'search_userFilter',
};
